import React from 'react'
import { Segment, Header } from 'semantic-ui-react'
import PopularForm from '../../components/advertisement/popularForm'

const NewPopular = () => {
  return (
    <div>
      <Segment color="black">
        <Header size="large"> Generate Popular List </Header>
        <PopularForm />
      </Segment>
    </div>
  )
}

export default NewPopular



// WEBPACK FOOTER //
// ./src/containers/advertisement/newPopular.js